import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=7bcd897b&lang=pug&"
import script from "./TypeSelector.vue?vue&type=script&lang=ts&"
export * from "./TypeSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports